module.exports = __webpack_public_path__ + "img/x.169c4462.jpg";